"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = require("react");
/**
 * Custom hook
 * Fetches City and Branch Data
 * @param {object} store
 */
function useDataFetch(store, errorCallback) {
  (0, _react.useEffect)(function () {
    store.appStore.searchPage.city.fetch(errorCallback);
    store.appStore.searchPage.branch.fetch('', 0, 0, errorCallback, 'city');
  }, []);
}
var _default = exports["default"] = useDataFetch;